<block-ui>
    <div class="row">
        <form class="form-group col-sm" [formGroup]="EmailForm">
            <input class="form-control form-control-sm" formControlName="Id" formControlName="Id" hidden>
            <label for="correo">Subscribir un correo</label>
            <div class="d-flex flex-row">
                <input class="form-control form-control-sm" (keyup)="AddEmail($event)" formControlName="Email"
                    type="email" name="correo" id="correo" placeholder="Correo...">
                <div>
                    <button class="form-control form-control-sm btn-light shadow-sm btn-st float-right">
                        <i class="fa fa-email" aria-hidden="false"></i>
                        Subscribir
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="tableFixHead mt-2">
        <table class="table table-striped mt table-sm table-hover">
            <thead style="background-color: #172749; color: white;">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Correo</th>
                    <th scope="col">Orden de Compra</th>
                    <th scope="col">Solicitud de Compra</th>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let subscriptionRow of subscriptions; let i = index" class="p-0">
                    <th scope="row">{{(i + 1)}}</th>
                    <td>{{subscriptionRow.Subscription.Email}}</td>
                    <td class="text-center">
                        <div class="border border-secondary rounded">
                            <i class="fa fa-{{(subscriptionRow.Subscription.PurchaseOrder && subscriptionRow.Subscription.PurchaseOrder.State) ? 'check': 'times'}}"></i>
                        </div>
                    </td>
                    <td class="text-center">
                        <div class="border border-secondary rounded">
                            <i class="fa fa-{{(subscriptionRow.Subscription.PurchaseRequest && subscriptionRow.Subscription.PurchaseRequest.State) ? 'check': 'times'}}"></i>
                        </div>
                    </td>
                    <td class="justify-content-center">
                        <i class="fa fa-edit" style="cursor: pointer;" title="Editar Subscripcion" (click)="GetSubscription(subscription, content)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <ng-template #content let-modal>
        <div class="modal-header">
            <h5 class="modal-title">Editar subscripción</h5>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="SubscriptionForm">
                <div class="form-group">
                    <label for="">Correo electrónico</label>
                    <input type="email" class="form-control form-control-sm" aria-describedby="emailHelp" formControlName="Email">
                </div>
            </form>
            <div class="row">
                <div class="col-sm-4 offset-sm-4">
                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
                </div>
                <div class="col-sm-4">
                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="CloseModal()"><i class="fa fa-times-circle" aria-hidden="true"></i> Cerrar&nbsp;</button>

                </div>
            </div>
        </div>
    </ng-template>
</block-ui>